import SeoLandingPage from "@/components/SeoLandingPage";
import heroImage from "@/assets/flooring-removal.jpg";

const FlooringRemoval = () => (
  <SeoLandingPage
    slug="flooring-removal-wisconsin"
    metaTitle="Flooring & Tile Removal Company | Northeast Wisconsin"
    metaDescription="Professional flooring removal in Green Bay, De Pere, Appleton, and Northeast Wisconsin. Tile, carpet, vinyl, laminate, hardwood, and underlayment removal."
    h1="Professional Flooring Removal in Northeast Wisconsin"
    heroImage={heroImage}
    heroIntro="Remove worn flooring, stubborn tile, and old underlayment without adding another disposal job to your renovation schedule."
    serviceName="Flooring Removal"
    bullets={[
      "Ceramic and porcelain tile removal.",
      "Carpet, pad, tack strip, and staple removal.",
      "Vinyl, laminate, floating floor, and linoleum removal.",
      "Approved hardwood, engineered wood, and underlayment removal.",
      "Adhesive and thinset reduction when included in the written scope.",
      "Material loading, hauling, disposal, and broom-clean completion.",
    ]}
    whyUs={[
      "Commercial removal equipment helps move difficult flooring efficiently.",
      "Dust-control planning protects adjacent living or working areas.",
      "Clear estimates distinguish flooring removal from adhesive or subfloor preparation.",
      "Residential and light-commercial service across Northeast Wisconsin.",
    ]}
    processSteps={[
      { title: "Identify the flooring", detail: "Send photos and approximate square footage, including transitions and any visible layers." },
      { title: "Confirm the finish condition", detail: "We define whether the scope includes flooring only, underlayment, tack strips, adhesive reduction, or other preparation." },
      { title: "Remove in sections", detail: "The crew isolates the area and uses methods suited to the flooring and substrate." },
      { title: "Haul the material", detail: "Removed flooring and approved debris are loaded out and the surface is swept for the next contractor." },
    ]}
    faqs={[
      { q: "What types of flooring do you remove?", a: "We remove tile, carpet, pad, vinyl, laminate, floating floors, many hardwood installations, and associated underlayment when included in the scope." },
      { q: "Do you remove tile and thinset?", a: "Yes. Tile removal is available, and thinset or adhesive reduction can be included after we review the substrate and the finish required by your flooring installer." },
      { q: "How much does flooring removal cost?", a: "Cost depends on material, square footage, number of layers, adhesive, access, furniture, and disposal weight. Send photos and measurements for an estimate." },
      { q: "Will the subfloor be ready for new flooring?", a: "We leave it broom-clean to the condition defined in the estimate. Repairs, leveling, grinding, moisture correction, and final installation preparation are separate unless specifically included." },
      { q: "Can you remove flooring from an occupied home or business?", a: "Often, yes. We plan work zones and a debris route to reduce disruption, but dust and noise are unavoidable during removal." },
    ]}
    ctaHeadline="Need old flooring out before installation?"
  />
);

export default FlooringRemoval;
